import { render } from "./NewRoomForm.vue?vue&type=template&id=3c3d1208"
import script from "./NewRoomForm.vue?vue&type=script&lang=js"
export * from "./NewRoomForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__